import {styled} from '@mui/material/styles'
import {Autocomplete, IconButton, Paper, Typography} from '@mui/material'
import {InfoOutlined} from '@mui/icons-material'

export const StyledAutocomplete = styled(Autocomplete)(({theme}) => ({
  margin: '12px',
  marginBottom: '0px',
  '& .MuiInputBase-root': {
    padding: '0px 8px 0px 8px',
    minHeight: '40px',
    height: '40px !important',
    boxSizing: 'border-box'
  },
  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.hpBase,
    opacity: 1
  },
  '& .MuiAutocomplete-clearIndicator': {
    display: 'none'
  },
  '& .MuiAutocomplete-endAdornment': {
    position: 'absolute',
    right: '36px',
    top: 'calc(50% - 12px)'
  }
}))

export const StyledTitle = styled(Typography)(({theme}) => ({
  padding: '8px 16px',
  fontSize: theme.typography.subtitle2.fontSize,
  color: theme.palette.hpAccentBlack
}))

export const StyledPaper = styled(Paper)({
  width: '100%',
  boxSizing: 'border-box'
})

export const StyledNoResultsContainer = styled('div')({
  padding: '4px 0px'
})

export const StyledNoResultsText = styled(Typography)(() => ({
  fontStyle: 'italic',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px 0'
}))

export const StyledHelpText = styled(Typography)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: '8px',
  color: theme.palette.text.secondary
}))

export const StyledListItemContent = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%'
})

export const StyledHighlightedText = styled('span')({
  fontWeight: 'bold'
})

export const StyledSearchText = styled(Typography)({
  whiteSpace: 'pre-wrap',
  display: 'inline',
  padding: '2px 0px'
})

export const StyledFlexContainer = styled('div')({
  display: 'flex',
  alignItems: 'center'
})

export const StyledClearIconButton = styled(IconButton)({
  marginRight: '-4px'
})

export const StyledAdornmentClearIconButton = styled(IconButton)({
  marginRight: '4px'
})

export const StyledIcon = styled((props) => <props.component {...props} />)(({theme}) => ({
  marginRight: '8px',
  color: theme.palette.hpBaseDarker
}))

export const StyledColoredIcon = styled((props) => <props.component {...props} />)(({theme}) => ({
  color: theme.palette.hpBaseDarker
}))

export const StyledStartAdornmentIcon = styled((props) => <props.component {...props} />)(({theme}) => ({
  marginLeft: '8px',
  marginRight: '-8px',
  color: theme.palette.hpBaseDarker
}))

export const StyledInfoIcon = styled(InfoOutlined)(({theme}) => ({
  cursor: 'pointer',
  marginRight: '2px',
  color: theme.palette.hpBaseDarker
}))

export const StyledAddedBadge = styled('span')(({theme}) => ({
  margin: `0px ${theme.spacing(1)}`,
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.hpGreenVividDark,
  fontWeight: theme.typography.fontWeightMedium,
  padding: `${theme.spacing(0.25)} ${theme.spacing(0.75)}`,
  borderRadius: theme.spacing(0.5),
  backgroundColor: theme.palette.success.light
}))

export const listBoxPropStyles = {
  maxHeight: '400px',
  overflowY: 'auto'
}
